import React from 'react';
import '../../styles/HomeStyle.css';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

const ColorButtonStyle = styled(Button)(({ style }) => ({
  ...style,
  flexDirection: 'column',
  display: 'flex',
  alignItems: 'flex-start',
  textAlign: 'start',
  textTransform: 'none',
  lineHeight: 1.2,
  letterSpacing: 0,
  minWidth: 0,
}));

function ColorButton({
  children, style, onClick, disabled = false,
}) {
  return (
    <ColorButtonStyle
      onClick={onClick}
      style={style}
      disabled={disabled}
    >
      {children}
    </ColorButtonStyle>
  );
}

export default ColorButton;
